import React, { useContext } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { useGetGroupId } from "../../hooks/useGetGroupId"

import { Valuation } from "../../components/start-your-valuation/Valuation"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { Container } from "../../components/common/container/Container"
import { checkPath } from '../../utils/validation-utils'

import "./LandingPage.scss"
import { Howitworks } from "../../components/Howitworks/Howitworks"

const LandingPage: React.FC = () => {
  const history = useHistory()
  const { search } = useLocation()
  const {
    actions: { addReg, addGroupId, addVehicleDetails, addExistsInStock },
    state: { registration, existsInStock },
    api: { getVehicleDetails, getStockStatus },
  } = useContext(AppContext) as AppContextInterface

  useGetGroupId(addGroupId)

  return (
    <div className="landingpage">
      <div className="hero">
        <Container>
          <h1>Sell your vehicle like a pro.</h1>
          <Valuation
            registration={registration}
            onRegistrationChange={(reg: string) => addReg(reg)}
            onSubmit={() => {
              addVehicleDetails({})
              getVehicleDetails(history)
              history.push(`/confirm-vehicle${checkPath(search)}`)
            }}
            addExistsInStock={() => addExistsInStock()}
						getStockStatus={() => { getStockStatus() }}
            stockStatus={existsInStock}
          />
        </Container>
      </div>
      <Howitworks />
    </div>
  )
}

export default LandingPage
